<!--
 * @Author: 李朋飞
 * @Date: 2021-12-02 09:55:53
 * @LastEditTime: 2023-11-07 14:44:13
 * @Description: 上传图频文件
-->
<template>
  <div class="l_UploadImages" v-loading.fullscreen="loading">
    <div
      v-for="(item, index) in FileList"
      :key="index"
      :style="{'width':width, 'height': `${uploadType == 'showFile' ? `calc(${height} + 40px)` : `${height}`}`}"
      class="l_UploadImages_file"
    >
      <div
        style="position: relative;"
        v-if="item.url"
        :style="{'width':width, 'height': height, border: '#EEEEEE 1px solid', display: 'flex', alignItems: 'center', justifyContent: 'center'}"
      >
        <!-- 显示图片 -->
        <img ref="imageRef" v-if="(item != '') && /\.(png|jpg|jpeg|bmp|gif)$/i.test(item.url)" :src="img_oss + item.url" alt="" class="l_UploadImages_file_img">
        <!-- 显示文件 -->
        <div class="l_UploadImages_file_video" v-else-if="(item != '') && /\.mp4$/i.test(item.url)">
          <video :src="img_oss+item.url" controls="controls" style="max-width: 100%; max-height: 100%;vertical-align: middle;">
            您的浏览器不支持 video 标签。
          </video>
        </div>
        <div class="l_UploadImages_file_file" v-else-if="item != ''">
          <div
            class="l_UploadImages_file_file_icon"
            :style="{
              background:fileBack[(item.url.split('.')[item.url.split('.').length-1]).substring(0,1).charCodeAt()%5],
              'font-size': (Number(width.split('px')[0])) / 4 + 'px',
            }"
          >
            {{(item.url.split('.')[item.url.split('.').length-1]).substring(0,1).toUpperCase()}}
          </div>
        </div>
        <div class="l_UploadImages_file_delate l_UploadImages_file_delate_show">
        </div>
        <!-- 删除按钮 -->
        <i
          v-if="uploadType != 'showFile'"
          :style="{
          'position': 'absolute',
          'top': `${(Number(width.split('px')[0])) / 20}px`,
          'right': `${(Number(width.split('px')[0])) / 20}px`,
          'cursor': 'pointer',
          'z-index': '100',
          }"
          class="el-icon-my-uploadDelete l_UploadImages_file_delate_show"
          @click="remove(item, index)"
        >
        </i>
        <!-- 下载按钮 -->
        <a
          class="l_UploadImages_file_delate_show" :download="item.name ? item.name : (item.url ? item.url.split('.')[0] : '')"
          :href="imgOssPath+item.url"
          :name="item.name ? item.name : (item.url ? item.url.split('.')[0] : '')"
          style="display:block;">
          <i
            :style="{
            'position': 'absolute',
            'top': `calc(50% - 9px)`,
            'left': `${(item != '') && (/\.(png|jpg|jpeg|bmp|gif)$/i.test(item.url) || (/\.mp4$/i.test(item.url))) ? `calc(50% - ${((Number(width.split('px')[0]) - 36) / 6) + 16 }px)` : `calc(50% - ${((Number(width.split('px')[0]) - 36) / 6)}px)`}`,
            'cursor': 'pointer',
            'z-index': '100',
            'color': '#333333'}"
            class="el-icon-my-uploadDowload l_UploadImages_file_delate_show"
          ></i>
        </a>
        <!-- 查看按钮 -->
        <i
          v-if="(item != '') && (/\.(png|jpg|jpeg|bmp|gif)$/i.test(item.url) || (/\.mp4$/i.test(item.url)))"
          :style="{
          'position': 'absolute',
          'top': `calc(50% - 9px)`,
          'right': `calc(50% - ${((Number(width.split('px')[0]) - 36) / 6) + 16 }px)`,
          'cursor': 'pointer',
          'z-index': '100',
          'color': '#333333'}"
          class="el-icon-my-uploadShow l_UploadImages_file_delate_show"
          @click="showImg(item)"
        >
        </i>
      </div>
      <div class="l_UploadImages_name" v-if="uploadType == 'showFile' || uploadType == 'uploadFile'" :title="item.name">{{item.name}}</div>
    </div>
    <div
      class="l_UploadImages_upload"
      :style="{'width':width, 'height': height,'color': iconColor}"
      @click="uploadImage"
      v-loading="UploadLoading"
      v-if="uploadType != 'showFile' && FileList.length < maxLenght && !isSaas"
    >
      <!-- <i :style="{'font-size': (Number(width.split('px')[0])) / 4 + 'px'}" class="el-icon-circle-plus"></i> -->
      <img :style="{'width':btnSize}" src="@/assets/add_big.png" alt="">
      <div :style="{'margin-top': '10px', 'color': '#000000', 'font-size': fontSize, 'height': Number(fontSize.split('px')[0])+4+'px', 'line-height': Number(fontSize.split('px')[0])+4+'px'}">添加</div>
    </div>
    <div
      class="l_UploadImages_upload"
      :style="{'width':width, 'height': height,'color': iconColor}"
      @click="uploadImage"
      v-loading="UploadLoading"
      v-if="uploadType != 'showFile' && FileList.length < maxLenght && isSaas"
    >
      <img src="@/assets/add_default.png">
    </div>
    <input type="file" title="" ref="uploadRef" :accept="uploadType == 'uploadImg' ?'image/*' : (uploadType == 'uploadVideo' ?'video/*' : '')" @change='submitImage' style="display:none;" :multiple="maxLenght > 1">
  <!-- 查看大图 -->
    <MaxImg ref="MaxImgRef"></MaxImg>
  </div>
</template>
<script>
import { PostData ,PostDataBlob} from "@/api/fetchdata";
import { getStorage } from '@/service/auth.js';
import axios from 'axios';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
export default {
  name: '',
  props: {
    uploadType: {
      type: String,
      default: 'uploadFile'
    },
    FileList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    maxLenght: {
      type: [Number, String],
      default: 10,
    },
    width: {
      type: [String],
      default: '100px',
    },
    height: {
      type: [String],
      default: '100px',
    },
    fontSize: {
      type: [String],
      default: '14px',
    },
    iconColor: {
      type: [String],
      default: '#409EFF',
    },
    btnSize: {
      type: [String],
      default: '#40px',
    },
    isSaas: {
      type: [Boolean],
      default: false,
    },
    isOcr: {
      type: [Boolean],
      default: false,
    },
    unshift: { // 插入到前面
      type: [Boolean],
      default: false,
    },
    maxSize: {
      type: [Number, String],
      default: 3,
    },
    upLoadIndex: {
      type: [Number, String],
      default: 0,
    },
    limit_image_size: {
      type: [Boolean],
      default: false,
    },
    image_size: {
      type: Array,
      default: () => {
        return [];
      }
    },
    image_format: {
      type: [Boolean],
      default: false,
    },
    image_consistent_scale: { // 保持图片比例
      type: [Boolean],
      default: false,
    },
  },
  data() {
    return{
      loading:false,
      uid: getStorage('uid'),
      token: getStorage('token'),
      UploadLoading: false,
      fileBack: ['#fe9940','#409dfe','#eb5e5e','#1fbf41','#679bf4'],
      imgOssPath: '/oss_img/',
    }
  },
  methods: {
    uploadImage() {
      this.$refs.uploadRef.click();
    },
    async submitImage(event) {
      let marr = [];
      let sarr = [];
      let FileList = event.target.files; // 上传的文件
      if((FileList.length + this.FileList.length) > this.maxLenght) {
        this.$message({message: `文件的最大上传数量不能超过${this.maxLenght}个`,type: 'warning',});
        this.$refs.uploadRef.value = '';
        return false;
      };
      let maxSize = this.uploadType == 'uploadFile' ? 100 : this.maxSize;
      for(let i=0; i<FileList.length; i++) {
        if(((FileList[i].size / 1024) / 1024) > maxSize) {
          this.$message({message: `文件大小不能超过${maxSize}M`,type: 'warning',});
          this.$refs.uploadRef.value = '';
          return false;
        }

        // 限制图片格式函数
        if(this.image_format) {
          const image_type = FileList[i].type === 'image/jpg' || FileList[i].type === 'image/png' || FileList[i].type === 'image/jpeg';
          if(!image_type) {
            this.$message.warning('图片格式要求jpg，png，jpeg！');
            this.$refs.uploadRef.value = '';
            return false;
          }
        }
        // 调用限制图片尺寸
        if(this.limit_image_size && this.image_size.length > 0) {
          let res = await this.limitFileWH(this.image_size[0], this.image_size[1], FileList[i]);
          if(!res) {
            this.$refs.uploadRef.value = '';
            return false;
          }
        }
        // 限制图片比例一比一
        if(this.image_consistent_scale) {
          let res = await this.limitPictureScale(FileList[i]);
          if(!res) {
            this.$refs.uploadRef.value = '';
            return false;
          }
        }
      };
      
      // 判断文件大小大于1M的切片上传
      for(let i=0; i<FileList.length; i++) {
        this.UploadLoading = true;
        this.$emit('UploadLoading', true);

        if(FileList[i].size > (1024 * 1024)) {
          marr.push(this.SliceUpload(FileList[i]))
        } else {
          sarr.push(this.singleUpload(FileList[i]))
        }
      }
      await Promise.all([...marr, ...sarr]);
      this.$emit('UploadLoading', false);
      this.$refs.uploadRef.value = '';
    },
    // 限制图片比例1：1
    limitPictureScale(file) {
      const isSize = new Promise(function (resolve, reject) {
        const _URL = window.URL || window.webkitURL
        const img = new Image()
        img.onload = function () {
          const valid = img.width == img.height;
          valid ? resolve() : reject()
        }
        img.src = _URL.createObjectURL(file)
      }).then(
        () => {
          return true
        },
        () => {
          this.$message({ type: 'warning', message:  '图片限制比例1：1'});
          return false
        }
      )
      return isSize   
    },
     // 上传图片事件限制图片尺寸
     limitFileWH (E_width, E_height, file) {
      const _this = this
      let imgWidth = ''
      let imgHight = ''
      const isSize = new Promise(function (resolve, reject) {
        const width = E_width
        const height = E_height
        const _URL = window.URL || window.webkitURL
        const img = new Image()
        img.onload = function () {
          imgWidth = img.width
          imgHight = img.height
          const valid = img.width == width && img.height == height;
          valid ? resolve() : reject()
        }
        img.src = _URL.createObjectURL(file)
      }).then(
        () => {
          return true
        },
        () => {
          this.$message({ type: 'warning', message:  '图片尺寸不符合要求'});
          return false
        }
      )
      return isSize
    },
    singleUpload(file) { // 小文件普通上传
      let form = new FormData();
      form.append('service', 'App.Oss.UploadFile');
      form.append('device_source', 'tj');
      form.append('file', file, file.name);
      return this.$http.post(this.$proxyurl, form, { headers: { Authorization: getStorage('token'), }, }).then(res => {
        if(res.data.ret == 200) {
          let obj = {
            name: file.name,
            url: res.data.data.file_token,
            type: file.name.split('.')[file.name.split('.').length-1],
            size: file.size
          };
          if(this.unshift){
            this.FileList.unshift(obj)
          } else {
            this.FileList.push(obj);
          }
          form = new FormData();
          this.businessLicenseOcr(res.data.data.file_token);
        } else {
          form = new FormData();
          this.$message({ type: 'warning', message:  res.data.msg});
        }
        this.UploadLoading = false;
      }).catch(error => console.log(error));
    },
    async SliceUpload(file) { // 大文件切片上传
      let file_type = file.name.split('.').pop() || '';
      const uploadParams = await this.getUploadId(file_type);
      let file_name = uploadParams.file_token + '.' + file_type;
      let file_size = file.size;
      let totalPieces = Math.ceil(file_size / (1024 * 1024)); // //计算文件切片总数, 每个文件切片大小定为1MB
      // 开始切片
      let start = 0;
      let end = 1024 * 1024;
      let index = 0;
      let chunks = []
      return await this.requestMultiUploadFiles(file, start, end, file_name, index, totalPieces, uploadParams, file_size, chunks, file_type);
    },
    async requestMultiUploadFiles(file, start, end, file_name, index, totalPieces, uploadParams, file_size, chunks, file_type) { //调用切片上传
      if(index < totalPieces) {
        try {
          const res = await this.multiUploadFiles(file.slice(start, end), file_name, index, totalPieces, uploadParams)
          let starN = end;
          let endN = 0;
          if (end > file_size) {
            endN = file_size;
          } else {
            endN = end + 1024 * 1024
          }
          index = index + 1;
          chunks.push(res)
          await this.requestMultiUploadFiles(file, starN, endN, file_name, index, totalPieces, uploadParams, file_size, chunks, file_type)
        } catch(err) {
          this.$message({type: 'warning', message: res});
        }
      } else {
        return await this.completeUpload(file_name, uploadParams, file.name, file_type, file_size);
      }
    },
    multiUploadFiles(file, file_name, index, total, uploadParams) { // 切片上传
      let form = new FormData();
      form.append('service', 'App.Oss.MultiUploadFiles');
      form.append('uid', this.uid);
      form.append('token', this.token);
      form.append('upload_id', uploadParams.upload_id);
      form.append('file_token', uploadParams.file_token);
      form.append('file', file, file_name);
      form.append('chunk', index);
      form.append('chunks', total);
      form.append('device_source', 'tj');
      return new Promise((resolve, reject) => {
        return axios.post(this.$proxyurl, form).then(res => {
          if (res.data.ret == 200) {
            resolve(res.data.data);
            form = new FormData();
          } else {
            this.UploadLoading = false;
            form = new FormData();
            reject(res.data.msg)
          }
        })
      })
    },
    completeUpload(file_name, uploadParams, name, file_type, file_size) {// 切片合并
      let parameter = {
        service: 'App.Oss.CompleteUpload',
        uid: this.uid,
        token: this.token,
        upload_id: uploadParams.upload_id,
        file_name,
      }
      return PostData(parameter).then(res => {
        if (res.data.ret == 200) {
          let obj = {
            name: name,
            url: file_name,
            type: file_type,
            size: file_size
          }
          if(this.unshift){
            this.FileList.unshift(obj)
          } else {
            this.FileList.push(obj);
          }
          this.businessLicenseOcr(file_name);
        } else {
          this.$message({type: 'warning', message: res.data.msg});
        }
        this.UploadLoading = false;
      })
    },
    //ocr识别
    businessLicenseOcr(url){
      if(this.isOcr){
        this.loading = true;
      let parameter = {
          microservices: "api/ocr/recognize/business/license",
          object: 'test1/WechatIMG6283.jpeg',
        };
       PostData(parameter).then((res) => {
          if (res.data.ret === 200) {
            this.$emit("ocrIdentify", res.data.data);
          } else {
            this.$message.warning(res.data.msg);
          }
        this.loading = false;
        });
      }
    },
    getUploadId(file_type) {
      let parameter = {
        service: 'App.Oss.GetUploadId',
        uid: this.uid,
        token: this.token,
        file_type,
      }
      return PostData(parameter).then(res => {
        if (res.data.ret == 200) {
          return {
            file_token: res.data.data.file_token,
            upload_id: res.data.data.upload_id,
          };
        } else {
          this.$message({type: 'warning', message: res.msg});
        }
      })
    },
    remove(item, index) { // 删除
      if(this.upLoadIndex) {
        this.$emit('removeImgItem', this.upLoadIndex);
      } else {
        this.FileList.splice(index, 1);
      }
    },
    showImg(item) { // 查看大图，视频
      if(/\.(png|jpg|jpeg|bmp|gif|mp4)$/i.test(item.url)){
        let imgList = [];
        let imgIndex = 0;
        this.FileList.map((FileListItem) => {
          if(/\.(png|jpg|jpeg|bmp|gif|mp4)$/i.test(FileListItem.url)) {
            imgList.push(FileListItem);
          }
        });
        this.$nextTick(() => {
          imgList.map((imgListItem, imgListIndex) => {
            if(imgListItem.url == item.url) {
              imgIndex = imgListIndex;
            }
          });
          this.$refs.MaxImgRef.show(imgList, imgIndex)
        });
      } else {
        this.$message({type: 'warning', message: '文件类型请下载后查看'});
      }
    },
  },
}
</script>
<style scoped>
.l_UploadImages{
  width: 100%;
  overflow: hidden;
}
.l_UploadImages_file{
  float: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 10px 10px 0;
  position: relative;
}
.l_UploadImages_name{
  width: 100%;
  height: 20px;
  text-align: center;
  line-height: 20px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.l_UploadImages_file_img{
  max-width: 100%;
  max-height: 100%;
}
.l_UploadImages_file_video{
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
}
.l_UploadImages_file_file{
  width: 100%;
  height: 100%;
  color:#fff;
  font-weight: bold;
}
.l_UploadImages_file_file_icon{
  width: 100%;
  height: 100%;
  color:#fff;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
.l_UploadImages_file:hover .l_UploadImages_file_delate_show{
  display: block;
}
.l_UploadImages_file_delate_show{
  display: none;
}
.l_UploadImages_file_delate{
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0,0,0,0.3);
  align-items: center;
  justify-content: center;
}
.l_UploadImages_file_delate_dowload{
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: 80%;
  z-index: 100;
  background-color: #FFFFFF;
  cursor: pointer;
  text-align: center;
  line-height: 100%;
}
.l_UploadImages_upload{
  float: left;
  margin-bottom: 10px;
  background: #F5F5F5;
  border: #EEEEEE 1px solid;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadFile/UploadFile.vue